import React from "react";
import { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { gettransactionlist, addjournal, searchfolios, getaccountcharts, getviewreceiptdetails, searchtenantforreceipt, gettransactiondetailsbyaudit, addrentreceipt, cancelreceipt, uploadbankfile, generatereceiptreport, generatedisbursementstatementreport, searchfolioforreceipt,addfolioreceipt } from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import { Steps, message, Button, Dropdown, Table, Input, DatePicker, Radio, Select, Spin } from 'antd';
import CustomModal from "../../../input-components/Modal";
import ShowValue from "../../../input-components/ShowValue";
import { format } from 'date-fns';
import SelectBox from "../../../input-components/selectBoxNew";
import TextBox from "../../../input-components/textbox";
import debounce from "lodash/debounce";
import { useFormik } from "formik";
import moment from "moment";
import { HomeOutlined, UploadOutlined, BankOutlined, WarningOutlined } from '@ant-design/icons';
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import NewTenantReceipt from "../newReceipt";
import TextArea from "../../../input-components/textarea"
import './transaction.css'
import { PrinterOutlined } from '@ant-design/icons';
import { dynamicUrl } from "../../../../Utilities/profileManagement";
import { formatAmount } from "../../../../components/CommonSection/Utility/Utility";

const initialValues = {
    date: "",
    accounts: "",
    details: "",
    taxInc: false,
    totalAmt: "",
    fromInv: "",
    supplier: ""
};

const Transaction = () => {
    const [transactionsLists, setTransactionsLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(1);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [openAddProperty, setOpenAddProperty] = useState(false);
    const [getDetails, setGetDetails] = useState(null);
    const [addNew, setAddNew] = useState(false);
    const [view, setView] = useState(false);
    const [agentId, setAgentId] = useState("");
    const [folioBal, setFolioBal] = useState(null);
    const [accArr, setAccArr] = useState(10);
    const [auditNo, setAuditNo] = useState(0);
    const [reverseReason, setReverseReason] = useState("");
    const [viewReverseReason, setViewReverseReason] = useState(false);
    const isTaxArr = [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
    ];
    const [viewTransactionDetails, setViewTransactionDetails] = useState(false);
    const inputRef = useRef();
    const [propertyimageitems, setPropertyimageitems] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchValue, setSearchValues] = useState("");
    const [rowIds, setRowIds] = useState("");
    const fetchRef = useRef(0);
    const [supplierArr, setSupplierArr] = useState([]);
    const [fetchingSupplier, setFetchingSupplier] = useState(false);
    const [fetchingToFolio, setFetchingToFolio] = useState(false);
    const [optionSupplier, setOptionSupplier] = useState([]);
    const [optionToFolio, setOptionToFolio] = useState([]);
    const [toValue, setToValue] = useState('')
    const [propertyId, setPropertyId] = useState("");
    const { Step } = Steps;
    const [takeMoneyFrom, setTakeMoneyFrom] = useState("");
    const [giveMoneyTo, setGiveMoneyTo] = useState("");
    const [ppenAddNewReceipt, setOpenAddNewReceipt] = useState(false);
    const [receiptDetails, setReceiptDetails] = useState({});
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(4);
    const [rentData, setRentData] = useState([
        { allocation: "Rent", due: "21 Sep 2024", description: "Paid to 21/09/2024", amountDue: "13 days", amount: "" }
    ]);
    const [depositData, setDepositData] = useState([
        { description: "", amount: "" }
    ]);
    const accountChartType = [
        { value: 1, label: "Income" },
        { value: 2, label: "Expense" },
    ];
    const ePaymentModes = [
        { value: 1, label: "Cash" },
        { value: 2, label: "Cheque" },
        { value: 3, label: "Card" },
        { value: 4, label: "EFT" }
    ];
    const [folioReceiptValues, setFolioReceiptValues] = useState({
        account: "",
        from: "",
        amount: "",
        date: moment().format("YYYY-MM-DD"),
        depositDescription: "",
        depositAmount: ""
    });

    const [unprocessedTransaction, setUnprocessedTransaction] = useState(0);
    const [supplierValue, setSupplierValues] = useState("");
    const [tenantValue, setTenantValues] = useState("");
    const [amount, SetAmount] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const ToastRef = useRef();
    const [bankFileId, setBankFileId] = useState(null);
    const [folioId, setFolioId] = useState("");
    const [checkFolioType, setCheckFolioType] = useState("");
    const [viewNewFolioReceipt, setViewNewFolioReceipt] = useState(false)
    const { RangePicker } = DatePicker;


    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setAgentId(parsedData.agentId)
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        if (userId) getSupportList(1, rows);
    }, [userId, searchText, purpose]);


    useEffect(() => {
        getAccountList();
    }, [])

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.addEventListener('change', handleFileUpload);
        }
        return () => {
            if (inputRef.current) {
                inputRef.current.removeEventListener('change', handleFileUpload);
            }
        };
    }, [agencyID]);


    const getAccountList = () => {
        const baseUrl = getaccountcharts + "?type=0";
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    const accArr = response.object.map(item => ({
                        label: item.text,
                        value: item.value
                    }));
                    setAccArr(accArr)
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };


    const getSupportList = (currentPage, totalRows) => {
        const baseUrl = gettransactionlist;
        let data = {
            AgencyId: agencyID,
            TabId: purpose,
            PageNo: currentPage,
            RecordsPerPage: totalRows, // ✅ Add this
            Search: searchText,
            Amount: amount ? parseFloat(amount) : null,
            StartDate: fromDate,
            EndDate: toDate
        };

        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    let transactionsData = response.object.transactiondetails;
                    setBankFileId(response.object.bankFileId);
                    setUnprocessedTransaction(response.object.unprocessedTransaction)
                    let transactionsList = transactionsData
                        .map((dis) => ({
                            auditNo: dis.auditNumer,
                            createdAt: moment(dis.createdAt).format("DD/MM/YYYY"),
                            transactionDate: moment(dis.transactionDate).format("DD/MM/YYYY"),
                            reference: dis.reference,
                            Type: dis.sType,
                            propertyAddress: dis.propertyAddress,
                            summary: dis.summary,
                            amount: formatAmount(dis.amount),
                            id: dis.propertyId,
                        }));
                    setTotalPages(response.totalCount)
                    setTransactionsLists(transactionsList);
                    setFolioId(response.object.folio)
                    setPropertyId("")
                } else {
                    message.error(response.message)
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const {
        errors,
        values,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setValues,
        resetForm
    } = useFormik({
        initialValues: initialValues,
        // validationSchema: addNewUserOpenHome,
        onSubmit: (values, action) => {
            AddupdateInvoice()
        },
    });


    const AddupdateInvoice = () => {
        const baseUrl = addjournal;
        const data = {
            FolioTo: giveMoneyTo,
            FolioFrom: takeMoneyFrom,
            Details: values.details,
            AccountChart: parseInt(values.accounts),
            Amount: parseFloat(values.totalAmt),
            IsTaxable: values.taxInc,
            LoggedUserId: parseInt(userId),
            AgencyId: parseInt(agencyID),
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    message.success(response.message)
                    getSupportList(1, rows);
                    setOpenAddProperty(false);
                } else {
                    //ToastRef.current.notify(["error", "error"]);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    // Handler for page change
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
        getSupportList(pageNumber, totalRows);
    };

    const tabColumns = {
        Status: {
            colorMap: {
                "Resolved": "#00A5A2",
                "Created": "#E5A000",
            },
            defaultColor: null
        }
    };

    const handleSearchValueChange = (value) => {
        setSearchText(value);
    };

    const onSelectedRowKeysChange = (data, id) => {
        const selectedIds = id.map(row => row.id).join(',');
        setRowIds(selectedIds);
        setPropertyId(data)
    }

    const closeProperty = () => {
        const baseUrl = window.location.pathname;
        navigate(baseUrl);
        setOpenAddProperty(false);
        setView(false);
        setAddNew(false);
        setDepositData([{ description: "", amount: "" }]);
    }

    const openProperty = () => {
        setOpenAddProperty(true);
    }

    const items = [
        {
            key: '1',
            label: (
                <a onClick={() => setViewNewFolioReceipt(true)}>
                    Folio Receipt
                </a>
            ),
        },
        {
            key: '2',
            label: (
                <a>
                    Folio Withdraw
                </a>
            ),
        },
        {
            key: '3',
            label: (
                <a onClick={openProperty}>
                    Journal
                </a>
            ),
        },
    ];

    useEffect(() => {
        agentUIDRef.current = agencyID;
    }, [agencyID]);

    const agentUIDRef = useRef(agencyID);

    const handleTakeMoneyFromChange = (value) => {
        setTakeMoneyFrom(value.value);
        setAuditNo(value.value)
    };

    // Function to handle "Give money to" selection
    const handleGiveMoneyToChange = (value) => {
        setGiveMoneyTo(value.value);
    };

    const debounceFetcher = useMemo(() => {
        const loadOptions = (value) => {
            const agentId = agentUIDRef.current;

            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);
            const baseUrl = searchfolios;
            const data = {
                Search: value,
                AgencyId: agentId
            };
            makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                baseUrl,
                "post",
                data,
                "",
                false
            )
                .then((response) => {
                    if (response.status === 1) {
                        let landingPageListData = response.list;

                        // Transform data to match Select options
                        const transformedData = landingPageListData.map((item) => ({
                            value: item.folio,
                            label: item.folioReference + `(${item.folio})`,
                        }));

                        // Update options and fetching state
                        if (fetchId === fetchRef.current) {
                            setOptions(transformedData);
                            setFetching(false);
                        }
                    } else {
                        setFetching(false);
                    }
                })
                .catch((error) => {
                    setFetching(false);
                });
        };
        return debounce(loadOptions, 800);
    }, []);

    const handleSearchProperty = (value) => {
        debounceFetcher(value);
        setSearchValues(value.value);
    };

    const handleClearProperty = () => {
        setFolioBal(null);
    };

    const viewreceiptdetails = (value) => {
        const baseUrl = getviewreceiptdetails;
        const apiUrl = `${baseUrl}?PropertyId=${value}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setReceiptDetails(response.object)
                    setDepositData([
                        {
                            description: `Deposit for ${response.object.propertyAddress}`,
                            amount: ""
                        }
                    ]);
                } else {
                    //handleparentsuccess(["warn", response.data.message]);
                }
            })
            .catch((error) => {
                //handleparentsuccess(["error", error]);
            });
    };

    const handleStatClick = (selectedPurpose) => {
        setPurpose(selectedPurpose);
    };

    const handleOpenReceipt = () => {
        setOpenAddNewReceipt(true);
        //

    };

    const closeReceipt = () => {
        setOpenAddNewReceipt(false);
        setReceiptDetails({});
        setDepositData([{ description: "", amount: "" }]);
        setSupplierValues("");
        setTenantValues("");
        setRentData([
            {
                allocation: "Rent",
                due: "",
                description: "",
                amountDue: "",
                amount: ""
            }
        ]);
        setDate(moment().format('YYYY-MM-DD'));
    };


    const handleReceiptSubmit = (formData) => {
        const payload = {
            Id: 0,
            Type: 1,
            Date: new Date().toISOString(),
            PaymentMode: selectedPaymentMode,
            Description: receiptDetails.propertyAddress,
            PropertyId: auditNo,
            AgencyId: agencyID,
            UserId: userId,
            ...formData,
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, addrentreceipt, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    ToastRef.current.notify(["success", res.message]);
                    closeReceipt();
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
            .catch(() => {
                ToastRef.current.notify(["error", "Something went wrong."]);
            });
    };

    const debounceFetcherSupplier = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptionSupplier([]);
            setFetchingSupplier(true);
            const baseUrl = searchtenantforreceipt;
            const data = {
                Search: value,
                RecordsPerPage: 10,
                PageNo: 1
            };

            makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                baseUrl,
                "post",
                data,
                "",
                false
            )
                .then((response) => {
                    if (response.status === 1) {
                        let supplierListData = response.list;
                        console.log(supplierListData)
                        // Transform data to match Select options
                        const transformedData = supplierListData.map((item) => ({
                            label: `${item.tenantReference} ${item.name} (${item.tenantAccountFolio})`,
                            value: item.id,
                            title: item.tenantReference + `(${item.tenantAccountFolio})`
                        }));
                        console.log(transformedData, 'transformedData')
                        // Update options and fetching state
                        if (fetchId === fetchRef.current) {
                            setOptionSupplier(transformedData);
                            setFetchingSupplier(false);
                        }
                    } else {
                        setFetchingSupplier(false);
                    }
                })
                .catch((error) => {
                    setFetchingSupplier(false);
                });
        };
        return debounce(loadOptions, 800);
    }, []);

    const handleSearchSupplier = (value) => {
        debounceFetcherSupplier(value);
        setSupplierValues(value.value);
        viewreceiptdetails(value.value);
        setAuditNo(value.value)
        setTenantValues(value.title)
    };

    const handleClearSupplier = () => {
        setSupplierValues("");
        setRentData([]);
        setReceiptDetails([]);
    };

    const viewTrasaction = (e, data) => {
        setViewTransactionDetails(true);
        GetDetailsApi(data.auditNo)
        const folioType = getContactTypeFromFolio(folioId)
        setCheckFolioType(folioType)
    }

    const getContactTypeFromFolio = (folio) => {
        const preText = folio?.trim().substring(0, 3).toUpperCase();

        switch (preText) {
            case "TEN":
                return "Tenant";
            case "OWN":
                return "Owner";
            case "SUP":
                return "Supplier";
            default:
                return "Other";
        }
    };

    const closeViewTrasaction = () => {
        setViewTransactionDetails(false)
    }

    const GetDetailsApi = (data) => {
        const url = gettransactiondetailsbyaudit + `?AuditId=${data}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "get", "", null, false)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setGetDetails(response.object);
                }
            })
            .catch((error) => {
                console.error("Error fetching ticket details:", error);
            })
            .finally(() => {
                //setLoading(false); // Set loading to false once API call completes
            });
    };

    const handlefolio = (data, folio) => {
        dynamicUrl(navigate, `accounts/folio?type=${data}&folio=${folio}`);
    }

    const handleProperty = (data) => {
        dynamicUrl(navigate, `viewPropertyDetails?propertyUID=${data}`);
    }

    const columns = [
        {
            title: "Contact",
            dataIndex: "contactName",
            key: "contactName",
            render: (text) => <span style={{ color: "#1890ff", cursor: "pointer" }}>{text}</span>,
        },
        {
            title: "Folio",
            dataIndex: "folio",
            key: "folio",
            render: (text) => {
                let type = "Supplier";
                if (text?.includes("TEN")) type = "Tenant";
                else if (text?.includes("OWN")) type = "Owner";

                return (
                    <span
                        onClick={() => handlefolio(type, text)}
                        style={{ color: "#1890ff", cursor: "pointer" }}
                    >
                        {text}
                    </span>
                );
            }
        },
        {
            title: "Chart Account",
            dataIndex: "accountChart",
            key: "accountChart",
        },
        {
            title: "Detail",
            dataIndex: "details",
            key: "details",
        },
        {
            title: "Tax",
            dataIndex: "tax",
            key: "tax",
            render: (value) => (value ? "Yes" : "No"),
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (amount) => `$${amount.toFixed(2)}`,
        },
    ];


    const handleReverse = (id) => {
        const payload = {
            ReceiptId: id,
            ReverseReason: reverseReason
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, cancelreceipt, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    ToastRef.current.notify(["success", res.message]);
                    setViewReverseReason(false)
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
            .catch(() => {
                ToastRef.current.notify(["error", "Something went wrong."]);
            });
    }

    const closeReverseReason = () => {
        setViewReverseReason(false)
    }

    const handleReverseReason = () => {
        setViewReverseReason(true)
    }

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async () => {
            const base64Content = reader.result.split(',')[1]; // remove "data:*/*;base64," prefix
            const payload = {
                FileName: file.name,
                AgencyId: agencyID,
                File: base64Content,
            };

            const apiUrl = uploadbankfile; // replace with actual URL
            makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "post", payload)
                .then((res) => {
                    if (res.status === 1) {
                        ToastRef.current.notify(["success", "Bank file imported successfully"]);
                        dynamicUrl(navigate, `Bankfile`, {
                            state: {
                                bankData: res.object.transactions,
                                fileName: payload.FileName,
                                fileId: res.object.id,
                            },
                        });

                    } else {
                        ToastRef.current.notify(["error", res.message]);
                    }
                })
                .catch(() => {
                    ToastRef.current.notify(["error", "Error uploading bank file"]);
                });
        };
        reader.readAsDataURL(file);
    };

    const handlePrint = (id) => {
        const baseUrl = generatereceiptreport;
        const data = {
            AgencyId: agencyID,
            ReceiptId: id,
        };

        showSpinner();

        fetch(baseUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then(async (res) => {
                if (!res.ok) throw new Error("Failed to generate receipt PDF");

                const disposition = res.headers.get("Content-Disposition");
                let fileName = `receipt_${id}.pdf`;

                if (disposition) {
                    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/);
                    const fallbackMatch = disposition.match(/filename="?([^"]+)"?/);
                    if (utf8Match?.[1]) {
                        fileName = decodeURIComponent(utf8Match[1]);
                    } else if (fallbackMatch?.[1]) {
                        fileName = fallbackMatch[1];
                    }
                }

                const blob = await res.blob();
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                ToastRef.current.notify(["success", "Receipt downloaded successfully."]);
            })
            .catch((err) => {
                ToastRef.current.notify(["error", err.message || "Something went wrong"]);
            })
            .finally(() => {
                hideSpinner();
            });
    };


    const handlePrintDisburse = (id) => {
        const baseUrl = generatedisbursementstatementreport;
        const data = {
            AgencyId: agencyID,
            DibsursmentId: id,
        };

        showSpinner();

        fetch(baseUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then(async (res) => {
                if (!res.ok) throw new Error("Failed to generate disbursement PDF");

                const disposition = res.headers.get("Content-Disposition");
                let fileName = `withdrawals_${id}.pdf`;

                if (disposition) {
                    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/);
                    const fallbackMatch = disposition.match(/filename="?([^"]+)"?/);
                    if (utf8Match?.[1]) {
                        fileName = decodeURIComponent(utf8Match[1]);
                    } else if (fallbackMatch?.[1]) {
                        fileName = fallbackMatch[1];
                    }
                }

                const blob = await res.blob();
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                ToastRef.current.notify(["success", "Disbursement downloaded successfully."]);
            })
            .catch((err) => {
                ToastRef.current.notify(["error", err.message || "Something went wrong"]);
            })
            .finally(() => {
                hideSpinner();
            });
    };

    const handleChangeSearch = (e) => {
        SetAmount(e.target.value)
    }

    const handleRangePickerChange = (dates, dateStrings) => {
        setFromDate(dateStrings[0]);
        setToDate(dateStrings[1]);
    };

    const handleSearch = () => {
        setTransactionsLists([]);
        getSupportList(1, rows);
    };

    const closeNewFolioReceipt = () => {
        setViewNewFolioReceipt(false)
        setToValue("")
    }

    const debounceFetcherToFolio = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptionToFolio([]);
            setFetchingToFolio(true);
            const baseUrl = searchfolioforreceipt;
            const data = {
                Search: value,
                RecordsPerPage: 10,
                PageNo: 1
            };

            makeRequestWithSpinner(
                showSpinner,
                hideSpinner,
                baseUrl,
                "post",
                data,
                "",
                false
            )
                .then((response) => {
                    if (response.status === 1) {
                        let supplierListData = response.list;
                        console.log(supplierListData)
                        // Transform data to match Select options
                        const transformedData = supplierListData.map((item) => ({
                            label: `${item.name}`,
                            value: item.id,
                        }));
                        console.log(transformedData, 'transformedData')
                        // Update options and fetching state
                        if (fetchId === fetchRef.current) {
                            setOptionToFolio(transformedData);
                            setFetchingToFolio(false);
                        }
                    } else {
                        setFetchingToFolio(false);
                    }
                })
                .catch((error) => {
                    setFetchingToFolio(false);
                });
        };
        return debounce(loadOptions, 800);
    }, []);

    const handleSearchToFolio = (value) => {
        debounceFetcherToFolio(value.label);
        setToValue(value.value)
    };

    const handleClearToFolio = () => {
        setToValue("")
    }

    const 
    handleAddFolioReceipt = (id) => {
        const payload = {
            FolioCode: toValue,
            Amount: parseFloat(folioReceiptValues.amount),
            AccountChartId: parseInt(folioReceiptValues.account),
            Date: folioReceiptValues.date,
            From: folioReceiptValues.from,
            Description: folioReceiptValues.depositDescription,
            PaymentMethod: selectedPaymentMode,
            AgencyId: agencyID
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, addfolioreceipt, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    ToastRef.current.notify(["success", res.message]);
                    setViewNewFolioReceipt(false)
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
            .catch(() => {
                ToastRef.current.notify(["error", "Something went wrong."]);
            });
    }

    const handleFolioReceiptChange = (e) => {
        const { name, value } = e.target;
        setFolioReceiptValues((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Transactions"} goback={false} extraData={true} />
                    <div className="material-work-desk-new bg-white m-3">
                        <ToastAlert ref={ToastRef} />

                        <div className="d-flex justify-content-between">
                            <div>
                                <Button className="ml-2 mr-2 withdraw-btn" type="default" icon={<UploadOutlined />} onClick={() => inputRef.current.click()}>
                                    Import Bank Files
                                </Button>
                                <Button onClick={handleOpenReceipt} className="mr-2 withdraw-btn" type="default" icon={<HomeOutlined />} >
                                    Add Tenant Receipt
                                </Button>
                                <Button className="mr-2 withdraw-btn" type="default" icon={<BankOutlined />} >
                                    Add Sale Receipt
                                </Button>
                                <Dropdown menu={{ items }} placement="bottomRight" className="mr-2">
                                    <Button className="mr-2 withdraw-btn">Other Action's</Button>
                                </Dropdown>
                                <Button className="mr-2 withdraw-btn" type="default" icon={<UploadOutlined />} >
                                    Direct Debit
                                </Button>
                            </div>
                            {unprocessedTransaction > 0 && (
                                <div className="bank-transaction-summary">
                                    <div className="bank-summary-box" onClick={() => navigate(`/agency/ReconcileTransaction?fileId=${bankFileId}`)}>
                                        <div className="bank-details">
                                            <div className="bank-count">{unprocessedTransaction}</div>
                                            <div className="bank-label">Bank Transactions</div>
                                        </div>
                                        <div className="bank-arrow">
                                            ➜
                                        </div>
                                    </div>
                                </div>)}
                        </div>

                        <div className="mt-3">
                            <span className={`stat-items ${purpose === 1 ? 'active' : ''}`} onClick={() => handleStatClick(1)}>This Month</span>
                            <span className={`stat-items ${purpose === 2 ? 'active' : ''}`} onClick={() => handleStatClick(2)}>Last Month</span>
                            <span className={`stat-items ${purpose === 3 ? 'active' : ''}`} onClick={() => handleStatClick(3)}>All</span>
                            <Input className="ml-5 mr-2 " style={{ width: 200 }} placeholder="Amount" value={amount} onChange={(e) => handleChangeSearch(e)} />
                            <RangePicker style={{ marginLeft: '10px' }} onChange={handleRangePickerChange} format="YYYY-MM-DD" />
                            <button className="Add-Property-button mt-4 ml-3" type="button" onClick={handleSearch}>
                                <div className="text-parent">
                                    <div className="text7" style={{ fontSize: "14px" }}>
                                        Search
                                    </div>
                                </div>
                            </button>
                        </div>
                        <AntdTableExample
                            showCheckbox
                            label="List Transactions"
                            dataSource={transactionsLists}
                            hideCol={"id"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            totalRecords={totalPages}
                            tagColumns={tabColumns}
                            onSearchValueChange={handleSearchValueChange}
                            onSelectedRowKeysChange={onSelectedRowKeysChange}
                            onRowClick={viewTrasaction}
                        />
                    </div>
                    <CustomModal title={"Journal Transfer"} width={800} closable={closeProperty} visible={openAddProperty} onCancel={closeProperty}
                        modalData={
                            <div className="p-3" style={{ marginTop: '-30px' }}>
                                <form onSubmit={handleSubmit} className="details-form" style={{ display: 'initial', width: '100%' }}>
                                    <div >
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-md-12 col-sm-12" >
                                                <label className='s1'>
                                                    Take money from
                                                </label>
                                                <Select
                                                    style={{ width: '100%', height: '40px' }}
                                                    className="landingPageSearchs"
                                                    mode="single"
                                                    showSearch
                                                    placeholder="Search for take money from"
                                                    labelInValue
                                                    filterOption={false}
                                                    onSearch={debounceFetcher}
                                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                                    options={options}
                                                    onChange={handleTakeMoneyFromChange}
                                                    allowClear
                                                    onClear={handleClearProperty}
                                                />
                                            </div>

                                            <div className="col-12 col-lg-6 col-md-12 col-sm-12" >
                                                <label className='s1'>
                                                    Give money to
                                                </label>
                                                <Select
                                                    style={{ width: '100%', height: '40px' }}
                                                    className="landingPageSearchs"
                                                    mode="single"
                                                    showSearch
                                                    placeholder="Search for give money to"
                                                    labelInValue
                                                    filterOption={false}
                                                    onSearch={debounceFetcher}
                                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                                    options={options}
                                                    onChange={handleGiveMoneyToChange}
                                                    allowClear
                                                    onClear={handleClearProperty}
                                                />
                                            </div>
                                        </div>
                                        {folioBal ?
                                            <div>
                                                {folioBal.balance <= 0 ?
                                                    <div style={{ padding: '20px', background: 'whitesmoke', borderRadius: '6px', width: '50%' }}>
                                                        <span style={{ fontWeight: '600', marginRight: '10px' }}><WarningOutlined style={{ marginRight: '5px' }} />Zero Balance</span><span>There are not funds in this folio.</span>
                                                    </div> : null}
                                                <div className="contacts-group">
                                                    <ShowValue Label="Balance" setData={folioBal.credit} />
                                                    <ShowValue Label="Outstanding Bills" setData={folioBal.dues} />
                                                    <ShowValue Label="Available Balance" setData={folioBal.balance} />
                                                </div>

                                            </div> : null}
                                        <div className="row">
                                            <TextBox value={values.details} name="details" label={"Details"} onChange={handleChange} onBlur={handleBlur} error={errors.details} touched={touched.details} />
                                            <SelectBox value={values.accounts} name="accounts" label={"Account"} options={accArr} onChange={(val) => setFieldValue("accounts", val.value)} onBlur={handleBlur} error={errors.accounts} touched={touched.accounts} />
                                            <SelectBox value={values.taxInc} name="taxInc" label={"Tax Inc"} options={isTaxArr} onChange={(val) => setFieldValue("taxInc", val.value)} onBlur={handleBlur} error={errors.taxInc} touched={touched.taxInc} />
                                            <TextBox value={values.totalAmt} name="totalAmt" label={"Amount"} onChange={handleChange} error={errors.totalAmt} onBlur={handleBlur} touched={touched.totalAmt} />
                                        </div>
                                    </div>
                                    <div className="property-details-buttons" style={{ marginBottom: "-50px" }}>
                                        <button className="pdb-cancel" type="reset" onClick={closeProperty}>Cancel</button>
                                        <button className="pdb-save-changes" type="submit">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        }
                        footer={[]}
                    />
                    <NewTenantReceipt
                        visible={ppenAddNewReceipt}
                        onClose={closeReceipt}
                        receiptDetails={receiptDetails}
                        supplierValue={supplierValue}
                        tenantValue={tenantValue}
                        ePaymentModes={ePaymentModes}
                        selectedPaymentMode={selectedPaymentMode}
                        setSelectedPaymentMode={setSelectedPaymentMode}
                        optionSupplier={optionSupplier}
                        fetchingSupplier={fetchingSupplier}
                        debounceFetcherSupplier={debounceFetcherSupplier}
                        handleSearchSupplier={handleSearchSupplier}
                        handleClearSupplier={handleClearSupplier}
                        onSubmit={handleReceiptSubmit}
                        ToastRef={ToastRef}
                        Tenant={true}
                    />

                    <CustomModal footer={null} title={`${getDetails?.transactionType} #${getDetails?.referenceId} - ${getDetails?.paymentDescription}`} width={1000} closable={closeViewTrasaction} visible={viewTransactionDetails} onCancel={closeViewTrasaction}
                        modalData={
                            <div>

                                <div className="details-form p-3" style={{ display: 'initial' }}>
                                    {getDetails?.transactionType === "Receipt" ?
                                        <div className="ml-3" style={{ float: 'right' }}>
                                            <PrinterOutlined className="mr-3" style={{ fontSize: "20px", cursor: 'pointer' }} onClick={() => handlePrint(getDetails?.receiptId)} />
                                            <Button className="withdraw-btn" type="default" onClick={handleReverseReason}>
                                                Reverse
                                            </Button>
                                        </div> : null}
                                    {getDetails?.transactionType !== "Receipt" && (
                                        <div className="ml-3" style={{ float: 'right' }}>
                                            <PrinterOutlined className="mr-3" style={{ fontSize: "20px", cursor: 'pointer' }} onClick={() => handlePrintDisburse(getDetails?.disbursementId)} />
                                        </div>)}
                                    <div className="contacts-group pl-2">
                                        <ShowValue Label='Created Date' setData={getDetails?.createdAt ? format(new Date(getDetails.createdAt), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                        <ShowValue Label='Paid By' setData={getDetails?.paidBy} />
                                        <ShowValue Label='Transaction Date' setData={getDetails?.transactionDate ? format(new Date(getDetails.transactionDate), 'dd/MM/yyyy hh:mm') : "N/A"} />
                                        {checkFolioType !== "Supplier" && (<ShowValue Label='Property' setData={getDetails?.propertyAddress ? getDetails?.propertyAddress : "N/A"} onClick={() => handleProperty(getDetails?.propertyUId)} link={true} />)}
                                        <ShowValue Label='Processed By' setData={getDetails?.processedBy} />

                                        <h6 style={{ marginTop: "20px" }}>Transaction Details</h6>
                                        <Table columns={columns} dataSource={getDetails?.transactionsDetails} pagination={false} />

                                        <div className="mr-5" style={{ textAlign: "right", marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
                                            Total: {getDetails?.totalAmount ? formatAmount(getDetails.totalAmount) : "0.00"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    />

                    <CustomModal title={"New Folio Receipt"} width={800} closable={closeNewFolioReceipt} visible={viewNewFolioReceipt} onCancel={closeNewFolioReceipt}
                        modalData={
                            <div>
                                {!toValue ?
                                    <div className="pd-undefined col-lg-12 col-sm-12 ">
                                        <label className="s1 mr-4">To Folio</label>
                                        <div>
                                            <Select
                                                style={{ width: "100%", height: "40px" }}
                                                className="landingPageSearchs"
                                                showSearch
                                                labelInValue
                                                placeholder="Search for tenant"
                                                filterOption={false}
                                                onSearch={debounceFetcherToFolio}
                                                notFoundContent={
                                                    fetchingToFolio ? <Spin size="small" /> : null
                                                }
                                                options={optionToFolio}
                                                onChange={handleSearchToFolio}
                                                allowClear
                                                onClear={handleClearToFolio}
                                                value={toValue}
                                            />
                                        </div>
                                    </div> :
                                    <div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="pd-undefined col-lg-12 col-sm-12 ">
                                                    <label className="s1 mr-4">To Folio</label>
                                                    <div>
                                                        <Select
                                                            style={{ width: "100%", height: "40px" }}
                                                            className="landingPageSearchs"
                                                            showSearch
                                                            labelInValue
                                                            placeholder="Search for tenant"
                                                            filterOption={false}
                                                            onSearch={debounceFetcherToFolio}
                                                            notFoundContent={
                                                                fetchingToFolio ? <Spin size="small" /> : null
                                                            }
                                                            options={optionToFolio}
                                                            onChange={handleSearchToFolio}
                                                            allowClear
                                                            onClear={handleClearToFolio}
                                                            value={toValue}
                                                        />
                                                    </div>
                                                </div>
                                                <SelectBox colVal={12} label="Account" name="account" options={accArr} value={folioReceiptValues.account} onChange={(val) =>
                                                    setFolioReceiptValues((prev) => ({
                                                        ...prev,
                                                        account: val.value
                                                    }))
                                                } />
                                                <TextBox colVal={12} label="From" name="from" value={folioReceiptValues.from} onChange={handleFolioReceiptChange} />
                                            </div>
                                            <div className="col-md-6">
                                                <TextBox colVal={12} label="Amount" name="amount" value={folioReceiptValues.amount} onChange={handleFolioReceiptChange} disabled />
                                                <TextBox colVal={12} label="Date" name="date" type="date" value={folioReceiptValues.date} onChange={handleFolioReceiptChange} />
                                            </div>
                                            <div className="ml-3">
                                                <label>Paid By</label>
                                                <Radio.Group
                                                    onChange={(e) => setSelectedPaymentMode(e.target.value)}
                                                    value={selectedPaymentMode}
                                                    style={{ display: 'flex', gap: '20px', marginTop: '5px' }}
                                                >
                                                    {ePaymentModes.map((mode) => (
                                                        <Radio key={mode.value} value={mode.value}>
                                                            {mode.label}
                                                        </Radio>
                                                    ))}
                                                </Radio.Group>
                                            </div>
                                        </div>

                                        <hr />

                                        {/* Allocation Section */}
                                        <div className="table">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: '#e2e2e2' }}>Allocate</th>
                                                        <th style={{ backgroundColor: '#e2e2e2' }}>Description</th>
                                                        <th style={{ backgroundColor: '#e2e2e2' }}>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Deposit</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="depositDescription"
                                                                value={folioReceiptValues.depositDescription}
                                                                onChange={handleFolioReceiptChange}
                                                                className="form-control"
                                                            />

                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                name="depositAmount"
                                                                value={folioReceiptValues.amount}
                                                                onChange={handleFolioReceiptChange}
                                                                className="form-control"
                                                                readOnly
                                                            />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                }

                            </div>
                        }
                        footer={<div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
                            <button onClick={closeNewFolioReceipt} style={{ marginRight: "10px" }} className="btn btn-light">
                                Cancel
                            </button>
                            <button style={{ background: "#348fb2", color: "white" }} onClick={() => handleAddFolioReceipt()} className="btn">
                                Submit
                            </button>
                        </div>}
                    />

                    <CustomModal title={"Reason"} width={600} closable={closeReverseReason} visible={viewReverseReason} onCancel={closeReverseReason}
                        modalData={
                            <div>
                                <div className="details-form p-3" style={{ display: 'initial' }}>
                                    <TextArea colVal={12} label="Reverse Reason" name="ReverseReason" value={reverseReason} onChange={(e) => setReverseReason(e.target.value)} />
                                </div>
                            </div>
                        }
                        footer={<div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
                            <button onClick={closeReverseReason} style={{ marginRight: "10px" }} className="btn btn-light">
                                Cancel
                            </button>
                            <button style={{ background: "#348fb2", color: "white" }} onClick={() => handleReverse(getDetails?.referenceId)} className="btn">
                                Submit
                            </button>
                        </div>}
                    />
                    <input
                        type="file"
                        accept=".ofx"
                        style={{ display: 'none' }}
                        ref={inputRef}
                    />

                </div>
            </div>
        </div>
    );
};

export default Transaction;
